import { getLoggedUser } from './../../../utils/helpers/tokenStorage';
import {
    DEFAULT_SEARCH_CATEGORY_NAME,
    DEFAULT_SEARCH_CATEGORY_NAME_MOBILE_CAMPAIGNS,
    DEFAULT_SEARCH_CATEGORY_NAME_MOBILE_DELIVERIES,
} from './../../../utils/constants';
import { isMobileOrTablet } from "../../../utils/helpers/mediaQueries";
import getLastValue from './getLastValue';

export const getDefaultSearchCategory = () => {
    const currentPathname = window.location.pathname;
    const campaignsPathname = '/campaigns';

    const value = getLastValue(currentPathname === campaignsPathname);

    if (isMobileOrTablet()) {
        if (currentPathname === campaignsPathname) {
            return value || DEFAULT_SEARCH_CATEGORY_NAME_MOBILE_CAMPAIGNS;
        } else {
            return value || DEFAULT_SEARCH_CATEGORY_NAME_MOBILE_DELIVERIES;
        }
    } else {
        return value || DEFAULT_SEARCH_CATEGORY_NAME;
    }
};